import { FC, useRef } from 'react';
import cx from 'classnames/bind';
import { Navigation } from 'swiper';
import { motion, AnimatePresence } from 'framer-motion';

import type { Swiper as SwiperType } from 'swiper/types';
import { Swiper } from '@/components/Swiper';
import Arrow from '@/assets/arrow.svg';
import Cursor from '@/assets/cursor.svg';
import type { IFormat, IBag, IFilter } from '@/types/pack';

import styles from './Question.module.scss';

const cn = cx.bind(styles);

const config = {
  className: cn('swiper-question'),
  spaceBetween: 50,
  modules: [Navigation],
  loop: true,
};

interface QuestionProps {
  title: string;
  answers: IFormat[] | IBag[] | IFilter[];
  isDefaultValue?: boolean;
  getCurrentSlideIndex: (e: SwiperType) => void;
  cursor?: string;
  setCursor?: (value: string) => void;
  firstPlay?: boolean;
}

const Question: FC<QuestionProps> = ({
  title,
  answers,
  isDefaultValue = false,
  getCurrentSlideIndex,
  cursor,
  setCursor,
  firstPlay,
}) => {
  const next = useRef(null);
  const prev = useRef(null);

  const refs = {
    next,
    prev,
  };

  return (
    <div className={cn('container')}>
      <div className={cn('title')}>{title}</div>
      <div className={cn('wrapper')}>
        <div className={cn('button-wrapper', 'button-wrapper-prev')}>
          <button className={cn('button')} type="button" ref={prev}>
            <img src={Arrow} alt="Стрелочка" />
          </button>
        </div>
        <Swiper
          onSlideChange={(e: SwiperType) => getCurrentSlideIndex(e)}
          {...config}
          refs={refs}
        >
          {!isDefaultValue && (
            <div className={cn('text', 'text-default')}>Не выбрано</div>
          )}
          {answers.map(({ text, id }) => (
            <div key={id} className={cn('text')}>
              {text}
            </div>
          ))}
        </Swiper>
        <div className={cn('button-wrapper', 'button-wrapper-next')}>
          <button className={cn('button')} type="button" ref={next}>
            <img src={Arrow} alt="Стрелочка" />
          </button>

          <AnimatePresence>
            {cursor === 'cursor1' && !firstPlay && (
              <motion.img
                initial={{ x: 10, y: 10, opacity: 1 }}
                animate={{ x: 0, y: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  repeat: 3,
                  repeatType: 'mirror',
                }}
                onAnimationComplete={() => {
                  if (setCursor) {
                    setCursor('cursor2');
                  }
                }}
                src={Cursor}
                alt="Курсор"
                className={cn('cursor')}
              />
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default Question;
